import { FullscreenOutlined, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import ButtonGroup from 'antd/lib/button/button-group';
import { default as React, useEffect } from 'react';
import { connect } from 'react-redux';
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { AppState } from '../../types/AppState';
import { setNumberOfEvents } from './actions';
import { findPathway } from './reducers';

interface Props {
    noOfEvents: number
    setNoOfEvents(noOfEvents: number): void
}
const MIN_EVENT_NO = 0
export const MAX_EVENT_NO = 20

const FIELD_NAME = "events"

// https://daveceddia.com/access-redux-store-outside-react/
const DisplayEvents = ({ noOfEvents, setNoOfEvents }: Props) => {

    const [form] = Form.useForm()

    useEffect(() => {
        form.setFieldsValue({ [FIELD_NAME]: noOfEvents });
    }, [noOfEvents, form])

    const onFinish = (values: any) => {
        const valueParsed = parseInt(values['events'])
        setNoOfEvents(valueParsed + 1)
    }

    return (
        <div>
            <Form
                name="display-events-form"
                form={form}
                layout={'inline'}
                initialValues={{ [FIELD_NAME]: noOfEvents }}
                onFinish={onFinish}
            >
                <Form.Item>
                    <ButtonGroup>
                        <Button id="zoom-in" shape="circle" size="small"><ZoomInOutlined /></Button>
                        <Button id="zoom-reset" shape="circle" size="small"><FullscreenOutlined /></Button>
                        <Button id="zoom-out" shape="circle" size="small"><ZoomOutOutlined /></Button>
                    </ButtonGroup>
                </Form.Item>
                <Form.Item
                    name={FIELD_NAME}
                    className="events"
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(rule, value) {
                                const valueParsed = parseInt(value)
                                if (!isNaN(valueParsed) && valueParsed >= MIN_EVENT_NO && valueParsed <= MAX_EVENT_NO) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(`This must be a number between ${MIN_EVENT_NO} and ${MAX_EVENT_NO}.`);
                            },
                        }),
                    ]}
                >
                    <Input size="small" style={{ width: 40 }} autoComplete={"off"} />
                </Form.Item>
                <Form.Item>
                    <Button shape="circle" htmlType="submit" size="small">Go</Button>
                </Form.Item>
            </Form>
        </div>
    )

}

const mapStateToProps = (state: AppState, ownProps: any) => {
    const pathway = findPathway(state.pathway.pathways, state.pathway.pathwayId!)
    return {
        noOfEvents: pathway!.eventConfigs.length - 1,
        ...ownProps
    }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    return {
        setNoOfEvents: (noOfEvents: number) => {
            dispatch(setNumberOfEvents(noOfEvents))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisplayEvents)